import cogoToast from "cogo-toast";
import httpRequest from "../../ajax";

import { 
  CREATE_FEED_POST,
  GET_FEEDS_RESULTS,
  CREATE_COMMENT_POST,
  DELETE_FEEDS_CATEGORY,
  DELETE_COMMENT,
  ERROR
} from "../actionTypes";

export const createFeedAction = (dispatch, data) => {
  return httpRequest("post", "/feeds/create", data)
    .then((response) => {
      // Handle both possible response structures
      const responseData = response.data?.data || response.data;
      if (responseData) {
        const action = { type: CREATE_FEED_POST, payload: responseData };
        dispatch(action);
        return {
          success: true,
          payload: responseData
        };
      }
      throw new Error('Invalid response format');
    })
    .catch((error) => {
      const errorMessage = error.response?.data?.message || error.message || 'Failed to create post';
      dispatch({
        type: ERROR,
        payload: errorMessage
      });
      throw new Error(errorMessage);
    });
};

export const createCommentPostAction = (dispatch, data) => {
  return httpRequest("post", "/feeds/comment", { feed_id: data.feed_id, content: data.content })
    .then((response) => {
      // Handle both possible response structures
      const responseData = response.data?.data || response.data;
      if (responseData) {
        // Ensure feed_id and commented_by_user are included in the payload for the reducer
        // IMPORTANT: Always use data.content for the comment text to avoid the API returning
        // the feed's content instead of the comment's content
        const payload = {
          ...responseData,
          feed_id: responseData.feed_id || data.feed_id,
          content: data.content, // Always use the user's input for comment content
          // Use API response user data if available, otherwise use data passed from component
          commented_by_user: responseData.commented_by_user || data.commented_by_user,
          commented_by_user_id: responseData.commented_by_user_id || responseData.commented_by_user?.id || data.commented_by_user?.id,
        };
        const action = { type: CREATE_COMMENT_POST, payload };
        dispatch(action);
        return {
          success: true,
          payload
        };
      }
      throw new Error('Invalid response format');
    })
    .catch((error) => {
      const errorMessage = error.response?.data?.message || error.message || 'Failed to create comment';
      dispatch({
        type: ERROR,
        payload: errorMessage
      });
      throw new Error(errorMessage);
    });
};

export const getFeedsAction = (dispatch, page) => {
  return httpRequest("get", `/feeds`)
    .then((response) => {
      // Handle both possible response structures
      const responseData = response.data?.data || response.data;
      if (responseData) {
        const action = { type: GET_FEEDS_RESULTS, payload: responseData };
        dispatch(action);
        return {
          success: true,
          payload: responseData
        };
      }
      throw new Error('Invalid response format');
    })
    .catch((error) => {
      const errorMessage = error.response?.data?.message || error.message || 'Failed to fetch feeds';
      dispatch({
        type: ERROR,
        payload: errorMessage
      });
      throw new Error(errorMessage);
    });
};

export const deleteFeedsAction = (dispatch, data) => {
  return httpRequest("delete", `/feeds/${data.item_id}`)
    .then((response) => {
      // Dispatch with the feed ID we're deleting (ensure reducer can find it)
      const payload = {
        id: data.item_id,
      };
      dispatch({ type: DELETE_FEEDS_CATEGORY, payload });
      return {
        success: true,
        payload
      };
    })
    .catch((error) => {
      const errorMessage = error.response?.data?.message || error.message || 'Failed to delete feed';
      dispatch({
        type: ERROR,
        payload: errorMessage
      });
      throw new Error(errorMessage);
    });
};

export const deleteCommentAction = (dispatch, data) => {
  return httpRequest("delete", `/feeds/comment/${data.comment_id}`)
    .then((response) => {
      // Handle both possible response structures
      const responseData = response.data?.data || response.data;
      dispatch({
        type: DELETE_COMMENT,
        payload: {
          comment_id: data.comment_id,
          feed_id: data.feed_id,
        }
      });
      return {
        success: true,
        payload: responseData
      };
    })
    .catch((error) => {
      const errorMessage = error.response?.data?.message || error.message || 'Failed to delete comment';
      dispatch({
        type: ERROR,
        payload: errorMessage
      });
      throw new Error(errorMessage);
    });
};
